<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden">

    <!-- Main -->
    <div class="flex flex-col flex-auto px-2 sm:px-1">

        <!-- Permissions & Sharing List -->
        <div class="w-full max-w-3xl">
            <!--Add New Note-->
            <div class="flex justify-end">
                <button 
                    mat-stroked-button 
                    class="hidden sm:inline-flex ml-3" 
                    [color]="'primary'"
                    matTooltip="Share"
                    [appAction]="{ action: 'share', item: asset }"
                    (click)="_fileManagerComponent.shared(asset)">
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:share'"></mat-icon>
                    <span class="ml-2">Share</span>
                </button>
            </div>
            <!-- Team members -->
            <div class="flex flex-col border-b" *ngIf="peopleAccess.length>0 && asset.id else noSharing">
                <ng-container *ngFor="let member of peopleAccess; let i = index">
                    <div class="flex sm:flex-row sm:items-center py-2 w-full">
                        <div class="flex items-center w-0 flex-1">
                            <div class="flex-shrink-0 mb-2 w-10 h-10"
                                [innerHTML]="(member['innerDiv'])"
                                [matTooltip]="member.user | fullName">
                            </div>
                            <div class="ml-4 w-0 flex-1">
                                <div class="font-medium truncate" *ngIf="member?.user?.firstName || member?.user?.lastName">
                                    {{member?.user?.firstName}} {{member?.user?.lastName}}
                                </div>
                                <div class="text-secondary italic truncate" *ngIf="!member?.user?.firstName && !member?.user?.lastName">---</div>
                                <div class="text-secondary truncate">{{member?.user?.email || '---'}}</div>
                                <div class="order-2 sm:order-1  sm:ml-0"  *ngIf="member.access !='OWNER' && !isViewer">
                                    <mat-form-field class="fuse-mat-dense w-40" [subscriptSizing]="'dynamic'">
                                        <mat-select
                                            [panelClass]="'perm-role-panel min-w-72 max-w-72 h-auto max-h-none'"
                                            [(ngModel)]="member.access" name="roleAcces"
                                            (ngModelChange)="change(member)"
                                            disableOptionCentering #roleSelect="matSelect">
                                            <mat-select-trigger class="text-md">
                                                <span>Role:</span>
                                                <span class="ml-1 font-medium">{{member.access| titlecase}}</span>
                                            </mat-select-trigger>
                                            <ng-container *ngFor="let role of roles">
                                                <mat-option  *ngIf="role.value !='Remove access'&&role.value!=='OWNER'"
                                                    class="h-auto py-4 leading-none" [value]="role.value">
                                                    <div class="font-medium">{{role.value}}</div>
                                                    <div
                                                        class="mt-1.5 text-sm whitespace-normal leading-normal text-secondary">
                                                        {{role.description}}</div>
                                                </mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="flex-none mt-3 w-60 h-6 ..." *ngIf="item.access =='OWNER'" >
                            <h2 *ngIf="item.access =='OWNER'" class="text-slate-500">{{item?.access }}</h2>
                        </div> -->
                        <!-- <div *ngIf="member.access =='OWNER'"  class="flex items-center mt-4 sm:mt-0 sm:ml-auto">
                            <div class="order-2 sm:order-1 ml-4 sm:ml-0">
                                <h2  class="text-slate-500">{{member?.access }}</h2>
                            </div>
                        </div> -->

                        <div class="flex items-center flex-shrink-0 mt-4 sm:mt-0 sm:ml-2" *ngIf="!isViewer">
                            <div class="order-2 sm:order-1 ml-4 sm:ml-0" *ngIf="member.access =='OWNER'" >
                                <h2  class="text-slate-500 font-inherit">{{member?.access }}</h2>
                            </div>
                            <!--TODO - replace delete with suspend user-->
                            <div class="order-1 sm:order-2 sm:ml-3">
                                <button mat-icon-button [disabled]="member.access =='OWNER'"
                                    (click)="deleteAccess(member.id, i)">
                                    <mat-icon class="text-hint" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>


            <!-- Loading template -->
            <ng-template #loading>
                Loading...
            </ng-template>

            <!-- No Note template -->
            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
            <ng-template #noSharing>
                <div class="p-4">
                    <div
                        class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                        <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                        <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No items to display</div>
                    </div>
                </div>
            </ng-template>
            <!-- <ng-template #noSharing>
                <div class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden">
                    <ng-container class="flex-auto sm:h-full">
                        <div class="p-4">
                            <div class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                                <mat-icon
                                    class="icon-size-24"
                                    [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                                <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No one has access to this asset</div>
                            </div>
                        </div>
                </ng-container>
            </div>
            </ng-template> -->

        </div>
    </div>

</div>


<!-- <ng-template #noItems>
<div class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden">
        <ng-container class="flex-auto sm:h-full">
            <div class="p-4">
                <div class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                    <mat-icon
                        class="icon-size-24"
                        [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                    <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No items to display</div>
                </div>
            </div>
    </ng-container>
</div>
</ng-template> -->